import { FormControlLabel, FormControlLabelProps, styled } from '@mui/material';

export const StyledFormControlLabel = styled((props: FormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme }) => ({
  background: theme.palette.primary.contrastText,
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
    fontWeight: 400,
    marginTop: 2,
  },
}));
